import { useEffect, useRef } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import Sortable from "sortablejs";
import { LI } from "../../../AbstractElements";
import { SharedLists } from "../../../Constants/Constants";
import { SharedListsTreeData } from "../../../Data/BonusUi/Tree";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SharedSortableLists = () => {
  const leftListRef = useRef<HTMLUListElement>(null);
  const rightListRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (leftListRef.current && rightListRef.current) {
      Sortable.create(leftListRef.current, {
        group: "shared",
        animation: 150,
      });

      Sortable.create(rightListRef.current, {
        group: "shared",
        animation: 150,
      });
    }
  }, []);

  return (
    <Col lg="4" sm="6">
      <Card>
        <CommonCardHeader title={SharedLists} span={SharedListsTreeData} />
        <CardBody>
          <Row>
            <Col xs="6">
              <ul className="list-group" id="mix-left" ref={leftListRef}>
                <LI>
                  <span>Item 1</span>
                </LI>
                <LI>
                  <span>Item 2</span>
                </LI>
                <LI>
                  <span>Item 3</span>
                </LI>
                <LI>
                  <span>Item 4</span>
                </LI>
                <LI>
                  <span>Item 5</span>
                </LI>
              </ul>
            </Col>
            <Col xs="6">
              <ul className="list-group" id="mix-right" ref={rightListRef}>
                <LI className="light-background">
                  <span>Item 6</span>
                </LI>
                <LI className="light-background">
                  <span>Item 7</span>
                </LI>
                <LI className="light-background">
                  <span>Item 8</span>
                </LI>
                <LI className="light-background">
                  <span>Item 9</span>
                </LI>
                <LI className="light-background">
                  <span>Item 10</span>
                </LI>
              </ul>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SharedSortableLists;
